<template>
  <div v-if="roundData && !isLoadingRound" class="flex flex-col gap-2 items-center absolute z-50 top-6 left-1/2 -translate-x-1/2">
    <h2 class="text-text-secondary center text-xs tracking-[1.5px] uppercase">{{ $t('viewer.hud.round', { n: currentRound }) }}</h2>
    <div v-if="bombPlantEvent && bombPlantEvent.tick < currentTick && !roundEnded" class="flex gap-1 items-center">
      <img class="h-5 filter-red" src="../../assets/icons/c4.svg">
      <h1 class="center text-semibold tracking-[0.5px] leading-[20px] text-danger-500">
        {{ formatTimer(getTimeOfTick(currentTick), true) }}
      </h1>
    </div>
    <div v-else class="flex items-center">
      <h1 class="center text-semibold tracking-[0.5px] leading-[20px] text-text-primary">
        {{ formatTimer(getTimeOfTick(currentTick), false) }}
      </h1>
    </div>
  </div>

  <TransitionGroup v-if="roundData" tag="div" name="kill-feed" class="flex flex-col gap-2 absolute z-50 top-6 right-6 text-white">
    <div
      v-for="kill in activeKills"
      :key="`kill-${kill.tick}-${kill.victimName}`"
      class="flex rounded-lg items-center justify-end"
      :style="{ opacity: killOpacity(kill, currentTick) }"
    >
      <div class="bg-gray-900 opacity-80 flex py-2 px-3 gap-3 items-center">
        <img v-if="kill.attackerBlinded" class="h-4" src="../../assets/icons/flashed_kill.svg">
        <h2 class="text-sm" :class="[kill.attackerSide === 'CT' ? 'text-text-ct' : 'text-text-t']">
          {{ kill.attackerName }}
        </h2>
        <img class="h-3" :src="`/img/icons/${kill.weapon}.png`">
        <img v-if="kill.noScope" class="h-4" src="../../assets/icons/noscope.svg">
        <img v-if="kill.thruSmoke" class="h-4" src="../../assets/icons/smoke_kill.svg">
        <img v-if="kill.isWallbang" class="h-4" src="../../assets/icons/wallbang.svg">
        <img v-if="kill.isHeadshot" class="h-4" src="../../assets/icons/headshot.svg">
        <h2 class="text-sm" :class="[kill.victimSide === 'CT' ? 'text-text-ct' : 'text-text-t']">
          {{ kill.victimName }}
        </h2>
      </div>
    </div>
  </TransitionGroup>
</template>

<script setup>
import moment from 'moment';
import formatTimer from '../../utils/demoViewer/formatTimer';
import { killOpacity } from '../../utils/demoViewer/killFeed';

const props = defineProps({
  roundData: Object,
  currentRound: Number,
  currentTick: Number,
  bombPlantEvent: Object,
  roundEnded: Boolean,
  activeKills: Array,
  getTimeOfTick: Function,
  isLoadingRound: Boolean,
});
</script>

<style scoped>
.kill-feed-move {
  transition: transform 0.3s ease;
}

.filter-red {
  filter: invert(34%) sepia(89%) saturate(3074%) hue-rotate(340deg) brightness(100%) contrast(88%);
}
</style>
